module.exports = __webpack_public_path__ + "static/media/MY.38e035f6.svg";